import { render, staticRenderFns } from "./SlideMenu.vue?vue&type=template&id=6ba6b629&"
import script from "./SlideMenu.vue?vue&type=script&lang=ts&"
export * from "./SlideMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports